import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import UploadDocumentsStep from '../../steps/UploadDocumentsStep';

export default function buildUploadDocumentsConfiguration({ invoices }) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.UPLOAD_DOCUMENTS,
    title: 'Sube el xml para cada factura que desees ceder',
    tooltipTitle:
      'El XML es un archivo descargable de tu facturador con información de tu factura',
    component: UploadDocumentsStep,
    props: { invoices },
  };
}
